module.exports = __webpack_public_path__ + "img/section5-item1.97a45c8a.svg";